<template>
  <v-container fluid style="overflow: hidden !important;">
   <v-layout row wrap v-if="status_login === 'T'">
      <v-flex sm12 md12 lg12 xl12 xs12>
        <div class="chatboxnonselect">
          <v-layout align-center justify-center column fill-height>
            <img src='https://image.flaticon.com/icons/svg/1443/1443136.svg' width="200" >
            <h2 class="mt-2">ไม่พบหน้าที่ต้องการ กรุณาตรวจสอบข้อมูลให้ถูกต้อง</h2>
          </v-layout>
        </div>
      </v-flex>
      </v-layout>
      </v-container>
</template>

<script>

export default {
  data () {
    return {
      status_login: ''
    }
  },
  created () {
    this.status_login = localStorage.getItem('status_login')
  }
}
</script>
<style type="text/css" scoped>
.container{
  padding: 0px !important;
}
.fixed-content {
    min-height:100%;
    /*position:fixed;*/
    overflow-y:scroll;
    overflow-x:hidden;
}
.content {
      padding: 0px 0px 0px !important;
}
>>>.chatboxnonselect{
    width: 100%;
    min-width: 10vw;
    height: calc(100vh - 64px);
    background-color:white;
    overflow-y: hidden;
  }
</style>
